import { render, staticRenderFns } from "./TextBloc.vue?vue&type=template&id=676d28ff&"
import script from "./TextBloc.vue?vue&type=script&lang=js&"
export * from "./TextBloc.vue?vue&type=script&lang=js&"
import style0 from "./TextBloc.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports